import { IMedicalService } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from './BaseService';

class MedicalServiceService extends BaseService<IMedicalService> {
  constructor() {
    super('medical-services');
  }
  canBulkDelete = true;

  generateLines = async (values: Record<string, unknown>) => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/generate-lines/`, values);
    return res.data;
  };

  importLisFile = async (importFile: File, context?: 'STANDARD' | 'OLOS') => {
    const formData = new FormData();
    formData.append('file', importFile);
    if (context) {
      formData.append('context', context);
    }
    const res = await axiosPrivate.post(`${this.modulePrefix}/import-lis-file/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  };

  importAggregatedLinesFromFile = async (
    importFile: File,
    attachmentName = 'import_file',
    context?: 'STANDARD' | 'OLOS'
  ) => {
    const formData = new FormData();
    formData.append(attachmentName, importFile);
    if (context) {
      formData.append('context', context);
    }
    const res = await axiosPrivate.post(
      `${this.modulePrefix}/import-aggregated-lines-from-file/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return res.data;
  };

  getImportTemplate = async (context?: 'STANDARD' | 'OLOS') => {
    const params = context ? { params: { context } } : {};
    axiosPrivate
      .get(`${this.modulePrefix}/aggregated_import_template/`, {
        responseType: 'blob',
        ...params
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const contentDisposition = res.headers['content-disposition'];
        if (contentDisposition?.indexOf('attachment') !== -1) {
          const filenameMatches = contentDisposition.match(
            /(?:.*filename\*|filename)=(?:([^'"]*)''|("))([^;]+)\2(?:[;`\n]|$)/
          );
          const filename = filenameMatches.pop();
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  };
}

export const medicalServiceService = new MedicalServiceService();
